import { css, Global } from "@emotion/react";
import styled from "@emotion/styled";

const Container = styled.div`
  height: 100%;
  background-color: ${(props) => props.background};
  background-size: 50px 50px;
  display: flex;
  position: relative;
  overflow: hidden;

  > * {
    height: 100%;
    min-height: 100%;
    width: 100%;
  }

  background-image: linear-gradient(
      0deg,
      transparent 24%,
      ${(props) => props.color} 25%,
      ${(props) => props.color} 26%,
      transparent 27%,
      transparent 74%,
      ${(props) => props.color} 75%,
      ${(props) => props.color} 76%,
      transparent 77%,
      transparent
    ),
    linear-gradient(
      90deg,
      transparent 24%,
      ${(props) => props.color} 25%,
      ${(props) => props.color} 26%,
      transparent 27%,
      transparent 74%,
      ${(props) => props.color} 75%,
      ${(props) => props.color} 76%,
      transparent 77%,
      transparent
    );
`;

const VignetteOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
  background: radial-gradient(
    circle,
    transparent 1%,
    rgba(0, 0, 0, ${(props) => props.opacity}) 100%
  );
  z-index: 1;
`;

const Expand = css`
  html,
  body,
  #root {
    height: 100%;
  }
`;

export const AtlasCanvasWidget = ({ children, background, color, vignetteOpacity = 0.5 }) => {
  return (
    <>
      <Global styles={Expand} />
      <Container
        background={background || "rgb(60, 60, 60)"}
        color={color || "rgba(255,255,255, 0.05)"}
      >
        {children}
        <VignetteOverlay opacity={vignetteOpacity} />
      </Container>
    </>
  );
};
